import React, { useState, useEffect } from 'react'
 import styled from 'styled-components';
import 'react-nice-dates/build/style.css';
import { ru } from 'date-fns/locale';
import { DateRangePicker, DatePickerCalendar} from 'react-nice-dates';
import PropTypes from 'prop-types';
import { format } from 'date-fns'
import { Button, Dialog, Divider, Typography } from '@mui/material';
import { colors } from 'styles/colors';
import { endOfMonth } from 'date-fns'
import { IMaskInput } from 'react-imask';
import { blocks } from 'utils/dndutils/cardformatters';

//стиль для single date picker

const StyledSingleDatePickerWrapper = styled.div`

  .nice-dates-day.-today {
    font-weight: bold !important;
  }
  .nice-dates-day:hover:not(.-selected):not(.-selected-start):not(.-selected-end):not(.-focus) {
    position: relative;
  }
  .nice-dates-day:before {
    background-color: #078376;
  }
  
`;

// стиль для компонента DateRangePicker
const DateRangePickerWrapper = styled.div`

.nice-dates-day {
  height: 50px !important;
}

.nice-dates-day.-today {
    font-weight: bold !important;
}
  .input {
  width: auto !important;
  height: 22px !important;
  font-size: 14px;
  text-align:center;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
     border-radius: 20px;
     border: 2px solid #078376;
     color: black;
}

.input:focus {
     outline: none;
     border: 2px solid #7fecd1;
     color: #686868;
}


.date-range{
display: flex;
flex-direction: row;
flex-wrap: wrap;
position: relative;

}

.nice-dates-day:before {
  background-color: #078376;
}

.date-range_arrow{
display: flex;
 align-items: center;
}

.nice-dates {
  
  &-popover {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 8px rgba(#000, .12);
    
    max-width: 350px;
    position: absolute;
    transform-origin: top;
    transform: perspective(1000px);
    transition-property: transform, opacity;
    transition-duration: 400ms;
    transition-timing-function: cubic-bezier(.4, .2, 0, 1.1);
    width: 100%;
    will-change: transform, opacity;
    z-index: 1000;

    &:not(.-open) {
      opacity: 0;
      width: 350px;
      pointer-events: none;
      transform: perspective(1000px) rotateX(-15deg);
      position: fixed;
      z-index: 9999;
    }
  }
}
  
`;

RangeDatePicker.propTypes = {
  start: PropTypes.object,
  end: PropTypes.object,
  formate: PropTypes.string,
  onChange:PropTypes.func,
};


// Компонент для отображения выбора диапазона дат
// сделан на основе DateRangePickerWrapper
// закидываем начальную и конечную дату, формат (необязательно) и callback функццию чтобы получить результат выбора
export default function RangeDatePicker({start, end, formate, onChange}) {
  // состояния дат
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  // сеттеры
  const $setStartDate = (value)=>{
    setStartDate(value);
    if (onChange) onChange([value,endDate]);
  }
  const $setEndDate = (value)=>{
    setEndDate(value);
    if (onChange) onChange([startDate,value]);
  }

  
  
return(
  <DateRangePickerWrapper>
  <DateRangePicker
      startDate={startDate}
      endDate={endDate}
      onStartDateChange={$setStartDate}
      onEndDateChange={$setEndDate}
      minimumLength={1}
      format= {formate ? formate : "dd.MM.yyyy"}
      locale={ru}
    >
      {({ startDateInputProps, endDateInputProps, focus }) => (
        <div className='date-range'>
          <input
            className={'input' + (focus === 'startDate' ? ' -focused' : '')}
            {...startDateInputProps}
            placeholder='Start date'
            size={formate ? formate.length : 10}
          />
          <span className='date-range_arrow'>-</span>
          <input
            className={'input' + (focus === 'endDate' ? ' -focused' : '')}
            {...endDateInputProps}
            placeholder='End date'
            size={formate ? formate.length : 10}
          />
        </div>
      )}
    </DateRangePicker>
</DateRangePickerWrapper>
);
}

// Компонент для отображения выбора одной даты
export function SingleDatePicker({defaultDate, formate, onChange}) {
  const [date, setDate] = useState(defaultDate)
  const $setDate = (value) => {
    setDate(value)
    if (onChange) onChange(value);
  }

  const today = new Date();
  const modifiers = {
    past: (date) => date < today,
    future: (date) => date > today,
  };

  const modifiersClassNames = {
    past: '-past',
    future: '-future',
  };

  console.log('DATE ADMIN')
  return (
    <DateRangePickerWrapper>
      <DatePickerCalendar
        date={date}
        onDateChange={$setDate}
        // @ts-ignore
        format={formate ? formate : "dd.MM.yyyy"}
        locale={ru}
        modifiers={modifiers}
        modifiersClassNames={modifiersClassNames}
      />
  </DateRangePickerWrapper>
  )
}


//компонент для выбора диапазона дат, включая один день + ограничения листалки
export function RestrictedRangePicker({ start, end, formate, onChange }) {
  const [startDate, setStartDate] = useState(start)
  const [endDate, setEndDate] = useState(end)

  const minLimitDate = new Date(2025, 10, 1)
  const maxLimitDate = endOfMonth(new Date())

  const $setStartDate = (value) => {
    setStartDate(value)
    if (onChange) onChange([value, endDate])
  }

  const $setEndDate = (value) => {
    setEndDate(value)
    if (onChange) onChange([startDate, value])
  }

  return (
    <DateRangePickerWrapper>
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={$setStartDate}
        onEndDateChange={$setEndDate}
        minimumLength={0}
        // Устанавливаем границы "от" и "до"
        minimumDate={minLimitDate}
        maximumDate={maxLimitDate}
        format={formate ? formate : "dd.MM.yyyy"}
        locale={ru}
      >
        {({ startDateInputProps, endDateInputProps, focus }) => (
          <div className='date-range'>
            <input
              className={'input' + (focus === 'startDate' ? ' -focused' : '')}
              {...startDateInputProps}
              placeholder='Начало'
              size={formate ? formate.length : 10}
            />
            <span className='date-range_arrow'>-</span>
            <input
              className={'input' + (focus === 'endDate' ? ' -focused' : '')}
              {...endDateInputProps}
              placeholder='Конец'
              size={formate ? formate.length : 10}
            />
          </div>
        )}
      </DateRangePicker>
    </DateRangePickerWrapper>
  )
}

export const DateMenu = ({
  date,
  onChange,
  bgColor = colors.elements,
  textColor = colors.white,
}) => {
  const [open, setOpen] = useState(false);

  // Локальное состояние для диалога
  const [localDate, setLocalDate] = useState(null);
  const [localTime, setLocalTime] = useState([0, 0]);
  const [localTimeText, setLocalTimeText] = useState('00:00');

  // Форматирование времени для отображения
  const formatTime = (dateObj) => {
    if (!dateObj) return '';
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    return (hours !== 0 || minutes !== 0)
      ? ` - ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
      : '';
  };

  // Открытие диалога
  const handleOpen = () => {
    const initialDate = date ? new Date(date) : new Date();
    const initialHours = date ? date.getHours() : 0;
    const initialMinutes = date ? date.getMinutes() : 0;

    setLocalDate(initialDate);
    setLocalTime([initialHours, initialMinutes]);
    setLocalTimeText(
      `${String(initialHours).padStart(2, '0')}:${String(initialMinutes).padStart(2, '0')}`
    );
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Обработчик изменения времени
  const handleUpdateTime = (value) => {
    const parts = value.split(':');
    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    setLocalTime([hours, minutes]);
    setLocalTimeText(value);
  };

  // Подтверждение выбора
  const handleAdd = () => {
    if (localDate) {
      const newDateTime = new Date(localDate);
      newDateTime.setHours(localTime[0], localTime[1], 0, 0);
      onChange(newDateTime);
      setOpen(false);
    }
  };

  // Отображение выбранной даты (закрытое состояние)
  const displayText = date
    ? `${date.toLocaleDateString('ru', { month: 'short', day: 'numeric', year: 'numeric' })}${formatTime(date)}`
    : 'не выбрано';

  return (
    <div>
      <div
        style={{
          backgroundColor: bgColor,
          borderRadius: '12px',
          padding: '3px',
          height: '26px',
          display: 'flex',
          flexFlow: 'row wrap',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleOpen}
      >
        <Typography
          variant="body1"
          sx={{
            marginLeft: '5px',
            marginRight: '5px',
            fontWeight: '200',
            fontSize: '13px',
            color: textColor,
          }}
          noWrap
        >
          {displayText}
        </Typography>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { borderRadius: '40px' } }}
      >
        <div style={{ height: '620px', width: '500px', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: '500', fontSize: '16px', marginTop: '20px', marginLeft: '20px' }}
            >
              {localDate?.toLocaleDateString('ru', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
            </Typography>
          </div>
          <Divider />
          <StyledSingleDatePickerWrapper>
            <SingleDatePicker
              defaultDate={localDate}
              onChange={(nd) => setLocalDate(nd)}
            />
            <Divider />
          </StyledSingleDatePickerWrapper>
          <Divider />
          <IMaskInput
            value={localTimeText}
            onAccept={(value) => handleUpdateTime(value)}
            style={{
              marginLeft: '42%',
              marginTop: '5px',
              marginBottom: '5px',
              width: '80px',
              height: '23px',
              fontSize: '14px',
              textAlign: 'center',
              borderRadius: '20px',
              border: '2px solid #078376',
            }}
            placeholder="00:00"
            mask="h:m"
            blocks={blocks}
            definitions={{ '#': /[1-9]/ }}
            overwrite
          />
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{ textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor: '#078376' }}
            >
              Отмена
            </Button>
            <Button
              variant="contained"
              onClick={handleAdd}
              sx={{ textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor: '#078376' }}
            >
              Изменить
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};